import { z } from 'zod';
export var ApplicationActionName = /*#__PURE__*/function (ApplicationActionName) {
  ApplicationActionName["ADD_REQUIREMENTS"] = "add_requirements";
  ApplicationActionName["CANCEL"] = "cancel";
  ApplicationActionName["CANCEL_DEFERRAL"] = "cancel_deferral";
  ApplicationActionName["CANCEL_REFUND"] = "cancel_refund";
  ApplicationActionName["CHANGE_INTAKE"] = "change_intake";
  ApplicationActionName["CHANGE_PROGRAM"] = "change_program";
  ApplicationActionName["COMPARE_REQUIREMENTS"] = "compare_requirements";
  ApplicationActionName["COMPLETE_ADMISSION"] = "complete_admission";
  ApplicationActionName["COMPLETE_EVALUATION"] = "complete_evaluation";
  ApplicationActionName["COMPLETE_VISA_STEPS"] = "complete_visa_steps";
  ApplicationActionName["CONFIRM_ENROLMENT"] = "confirm_enrolment";
  ApplicationActionName["CONFIRM_ENROLMENT_EARLY"] = "confirm_enrolment_early";
  ApplicationActionName["CREATE_ADMIN_NOTE"] = "create_admin_note";
  ApplicationActionName["CREATE_CUSTOMER_NOTE"] = "create_customer_note";
  ApplicationActionName["EDIT_CANCEL_REASON"] = "edit_cancel_reason";
  ApplicationActionName["EDIT_WITHDRAW_REASON"] = "edit_withdraw_reason";
  ApplicationActionName["DECIDE_ACCEPTED"] = "decide_accepted";
  ApplicationActionName["DECIDE_REJECTED"] = "decide_rejected";
  ApplicationActionName["DECIDE_PROGRAM_CLOSED"] = "decide_program_closed";
  ApplicationActionName["DECIDE_WAITLISTED"] = "decide_waitlisted";
  ApplicationActionName["FINISH_DEFERRAL"] = "finish_deferral";
  ApplicationActionName["FINISH_REFUND"] = "finish_refund";
  ApplicationActionName["RECOMMENDED_PROGRAM"] = "get_recommended_programs";
  ApplicationActionName["REQUEST_DEFERRAL"] = "request_deferral";
  ApplicationActionName["REQUEST_TUITION_DEPOSIT_REFUND"] = "request_tuition_deposit_refund";
  ApplicationActionName["RESTART_ADMISSION"] = "restart_admission";
  ApplicationActionName["RESTART_DECISION"] = "restart_decision";
  ApplicationActionName["RESTART_EVALUATION"] = "restart_evaluation";
  ApplicationActionName["RESTART_SUBMISSION"] = "restart_submission";
  ApplicationActionName["RESTART_VISA_STEPS"] = "restart_visa_steps";
  ApplicationActionName["STAGE_CHANGE_SUBMISSION"] = "stage_change_submission";
  ApplicationActionName["START_DEFERRAL"] = "start_deferral";
  ApplicationActionName["START_REFUND"] = "start_refund";
  ApplicationActionName["SUBMIT_TO_SCHOOL"] = "submit_to_school";
  ApplicationActionName["UNDO_CANCEL"] = "undo_cancel";
  ApplicationActionName["UNDO_WITHDRAW"] = "undo_withdraw";
  ApplicationActionName["WITHDRAW"] = "withdraw";
  ApplicationActionName["UNDO_CONFIRM_ENROLMENT"] = "undo_enrolment_confirmed";
  ApplicationActionName["UNDO_CONFIRM_ENROLMENT_EARLY"] = "undo_enrolment_confirmed_early";
  ApplicationActionName["VIEW_COMMISSION"] = "view_commission";
  ApplicationActionName["EDIT_COMMISSION"] = "edit_commission";
  return ApplicationActionName;
}({});
export var SimpleStatusApplicationAction = z.object({
  actionId: z["enum"]([ApplicationActionName.COMPLETE_EVALUATION, ApplicationActionName.SUBMIT_TO_SCHOOL, ApplicationActionName.COMPLETE_VISA_STEPS, ApplicationActionName.CONFIRM_ENROLMENT, ApplicationActionName.DECIDE_ACCEPTED, ApplicationActionName.DECIDE_REJECTED, ApplicationActionName.DECIDE_PROGRAM_CLOSED, ApplicationActionName.DECIDE_WAITLISTED, ApplicationActionName.RESTART_DECISION, ApplicationActionName.CONFIRM_ENROLMENT_EARLY, ApplicationActionName.START_DEFERRAL, ApplicationActionName.START_REFUND, ApplicationActionName.CANCEL_REFUND, ApplicationActionName.FINISH_REFUND, ApplicationActionName.RESTART_EVALUATION, ApplicationActionName.RESTART_SUBMISSION, ApplicationActionName.RESTART_ADMISSION, ApplicationActionName.RESTART_VISA_STEPS, ApplicationActionName.UNDO_CANCEL, ApplicationActionName.UNDO_WITHDRAW, ApplicationActionName.UNDO_CONFIRM_ENROLMENT, ApplicationActionName.UNDO_CONFIRM_ENROLMENT_EARLY])
});
export var CancelWithdrawActionName = z["enum"]([ApplicationActionName.CANCEL, ApplicationActionName.EDIT_CANCEL_REASON, ApplicationActionName.WITHDRAW, ApplicationActionName.EDIT_WITHDRAW_REASON]);
var CancelApplicationAction = z.object({
  actionId: z["enum"]([ApplicationActionName.CANCEL, ApplicationActionName.EDIT_CANCEL_REASON]),
  actionData: z.object({
    cancellationReasonKey: z.string(),
    cancellationReasonAdditionalNote: z.string().optional()
  })
});
var WithdrawApplicationAction = z.object({
  actionId: z["enum"]([ApplicationActionName.WITHDRAW, ApplicationActionName.EDIT_WITHDRAW_REASON]),
  actionData: z.object({
    withdrawalReasonKey: z.string(),
    withdrawalReasonAdditionalNote: z.string().optional()
  })
});
export var CompleteAdmissionAction = z.object({
  actionId: z.literal(ApplicationActionName.COMPLETE_ADMISSION),
  actionData: z.object({
    programs: z.array(z.object({
      legacyIntakeId: z.number(),
      legacyProgramId: z.number().optional(),
      actualStartDate: z.string(),
      alternateActualStartDate: z.string().optional()
    }))
  })
});
export var EditCommissionAction = z.object({
  actionId: z.literal(ApplicationActionName.EDIT_COMMISSION),
  actionData: z.object({
    commissionRate: z.string(),
    comment: z.string()
  })
});
export var ApplicationAction = z.discriminatedUnion('actionId', [SimpleStatusApplicationAction, CancelApplicationAction, WithdrawApplicationAction, CompleteAdmissionAction, EditCommissionAction]);